import { AlertColor } from '@mui/material'
import create from 'zustand'

interface GlobalSnackbarStore {
  isSnackbarOpen: boolean
  openSnackbar: () => void
  closeSnackbar: () => void
  triggerSuccessMessage: (message: string, autoHideDuration?: number | null) => void
  triggerErrorMessage: (message: string, autoHideDuration?: number | null) => void
  triggerInfoMessage: (message: string, autoHideDuration?: number | null) => void
  setMessage: (message: string) => void
  message: string
  severity: AlertColor
  autoHideDuration: number | null
}

export const useGlobalSnackbarStore = create<GlobalSnackbarStore>()((set, get) => ({
  isSnackbarOpen: false,
  message: '',
  severity: 'success',
  autoHideDuration: 6000,
  openSnackbar: () => {
    set({ isSnackbarOpen: true })
  },
  closeSnackbar: () => {
    set({ isSnackbarOpen: false })
  },
  setMessage: (message: string) => {
    set({ message })
  },
  triggerSuccessMessage: (message: string, autoHideDuration?: number | null) => {
    set({ severity: 'success', autoHideDuration: autoHideDuration ?? 6000 })
    get().setMessage(message)
    get().openSnackbar()
  },
  triggerInfoMessage: (message: string, autoHideDuration?: number | null) => {
    set({ severity: 'info', autoHideDuration: autoHideDuration ?? 6000 })
    get().setMessage(message)
    get().openSnackbar()
  },
  triggerErrorMessage: (message: string, autoHideDuration?: number | null) => {
    set({ severity: 'error', autoHideDuration: autoHideDuration ?? 6000 })
    get().setMessage(message)
    get().openSnackbar()
  },
}))
